import catalogue1 from "./catalogue1";
import catalogue2 from "./catalogue2";
import catalogue3 from "./catalogue3";
import catalogue4 from "./catalogue4";

export default [catalogue1, catalogue2, catalogue3, catalogue4];
